import * as React from 'react';
// import './ProgressTracker.scss';
export var ProgressTracker = function (_a) {
    var _b = _a.percentage, percentage = _b === void 0 ? 0 : _b;
    var progress = 300 - (percentage / 100) * 229;
    var rotationProgress = 270 * (percentage / 100);
    // const percentageAtEitherEndpoint = [0, 100].includes(percentage);
    var ActiveCircleProgress = function () {
        return (React.createElement("circle", { className: "ProgressPerk__circleProgress circle-animate", 
            // className="ProgressPerk__circleProgress"
            style: { strokeDashoffset: progress }, cx: "57", cy: "57", r: "48", stroke: "#F96302" }));
    };
    var ActiveCircleProgressDot = function () {
        return (React.createElement("circle", { className: "ProgressPerk__circleSmallDot dot-animate", style: { transform: "rotate(".concat(rotationProgress, "deg)") }, cx: "107", cy: "57", r: "10" }));
    };
    var ProgressPerk = function () {
        return (React.createElement("div", { className: "ProgressPerk__progress_Main" },
            React.createElement("svg", { viewBox: "0 0 115 115", className: "ProgressPerk__svg" },
                React.createElement("circle", { className: "ProgressPerk__circle", cx: "57", cy: "57", r: "48" }),
                React.createElement("defs", null,
                    React.createElement("linearGradient", { id: "red", x1: "0%", y1: "0%", x2: "100%", y2: "0%" },
                        React.createElement("stop", { offset: "100%", stopColor: "#f96302", stopOpacity: "0.9" }))),
                React.createElement(ActiveCircleProgress, null),
                React.createElement(ActiveCircleProgressDot, null))));
    };
    return React.createElement(ProgressPerk, null);
};
